import { Injectable } from '@angular/core';
import { SettingsService } from '@barthauer/abc/core';
import { LoginSettingsService, ProfileSettingsService } from '@barthauer/abc/core/authentication';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from '@barthauer/abc/core/data';
import { ActivatedRoute } from '@angular/router';
import { AppSetting, AppSettings, IAppSettings } from '../models/app.settings.model';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService extends SettingsService<IAppSettings, AppSettings, AppSetting> {
  constructor(
    abcConfigService: AbcConfigService,
    data: DataService,
    loginSettingsService: LoginSettingsService,
    profileSettingsService: ProfileSettingsService,
    protected route: ActivatedRoute,
  ) {
    super(abcConfigService, data, loginSettingsService, profileSettingsService, 'AppSettings', AppSettings, AppSetting);
  }
}
